export default "__VITE_ASSET__D6kHj3Sp__"